<template lang="pug">
  .income.pb-12.mb-12
    v-container.white.pt-3.pb-1.px-0(style="max-width:600px;")
      .sticky-header-container(:style="headerHeight")
        .sticky-header(:class="headerClass" )
          div.mb-0.px-4(flat outlined)
            v-row.px-3
              v-col.py-0.pl-0.pr-2()
                v-card( flat outlined)
                  v-card-text.py-2.border-bottom
                    div.c1.primary400--text This Month
                    v-layout
                      div.s2.primary500--text.text-capitalize.mr-1 income
                      v-tooltip(top color="basic1100" max-width="246px")
                        template(v-slot:activator='{ on }')
                          div.my-auto(v-on='on' style="width:16px; height:16px;")
                            eva-icon(name="info-outline" :fill="$vuetify.theme.themes[$theme].primary500" height="16" width="16")
                        .c1.basic100--text.my-2 {{ $t('tooltip.income')}}
                    div.h6.primary500--text {{ incomesSummaryMonth? incomesSummaryMonth.total : 0 | displayFormattedPrice($vuetify.breakpoint.width)}}
                  v-card-text.py-2.px-4
                    v-layout
                      div.c1.success500--text.text-capitalize.mr-1 Settled
                      v-tooltip(bottom color="basic1100" max-width="246px")
                        template(v-slot:activator='{ on }')
                          div.my-auto(v-on='on' style="width:16px; height:16px;")
                            eva-icon(name="info-outline" :fill="$vuetify.theme.themes[$theme].success500" height="16" width="16")
                        .c1.basic100--text.my-2 {{ $t('tooltip.settled')}}
                    div.c2.success500--text {{ incomesSummaryMonth? incomesSummaryMonth.total_paid : 0 | displayPrice }}
              v-col.py-0.pl-2.pr-0()
                v-card( flat outlined)
                  v-card-text.py-2.border-bottom
                    div.c1.primary400--text This Year
                    v-layout
                      div.s2.primary500--text.text-capitalize.mr-1 unpaid
                      v-tooltip(top color="basic1100" max-width="246px")
                        template(v-slot:activator='{ on }')
                          div.my-auto(v-on='on' style="width:16px; height:16px;")
                            eva-icon(name="info-outline" :fill="$vuetify.theme.themes[$theme].primary500" height="16" width="16")
                        .c1.basic100--text.my-2 {{ $t('tooltip.unpaid')}}
                    div.h6.primary500--text {{ incomesSummaryYear? incomesSummaryYear.total_unpaid : 0 | displayFormattedPrice($vuetify.breakpoint.width)}}
                  v-card-text.py-2.px-4
                    v-layout
                      div.c1.danger500--text.text-capitalize.mr-1 Overdue
                      v-tooltip(bottom color="basic1100" max-width="246px")
                        template(v-slot:activator='{ on }')
                          div.my-auto(v-on='on' style="width:16px; height:16px;")
                            eva-icon(name="info-outline" :fill="$vuetify.theme.themes[$theme].danger500" height="16" width="16")
                        .c1.basic100--text.my-2 {{ $t('tooltip.overdue')}}
                    div.c1.danger500--text(style="font-weight:700 !important") {{ incomesSummaryYear?incomesSummaryYear.total_overdue : 0 | displayPrice }}
            v-row.mt-1(no-gutters align="center")
              v-col.py-2.pr-2
                v-text-field(v-model="searchText" placeholder='Search income' hide-details dense outlined height="40" background-color="basic200" @focus="searchBarExpand = true" @blur="checkSearch")
                  template(v-slot:append)
                    eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600" )
              v-col.py-2.pr-2.shrink
                v-menu(bottom left offset-y)
                  template(v-slot:activator='{ on }')
                    template(v-if="searchBarExpand")
                      v-btn.elevation-0.pa-0(color="transparent" small icon v-on='on')
                        eva-icon(name="settings-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="23" style="margin-top: 2px")
                    template(v-else)
                      v-btn.elevation-0.pa-0(text color="transparent" :ripple="false" x-small light v-on='on')
                        eva-icon(name="settings-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="15" style="margin-top: 2px")
                        .label.primary400--text Action
                  v-list.pa-0
                    v-list-item(@click="bulkReminder")
                      v-list-item-content
                        v-list-item-title
                          .s2.basic800--text| Send reminder
                    v-list-item(v-if="yBooksSubscription.limitations.reminder > 0" @click="bulkScheduleReminder")
                      v-list-item-content
                        v-list-item-title
                          .s2.basic800--text| Schedule reminder
                    v-list-item(@click="bulkDelete")
                      v-list-item-content
                        v-list-item-title
                          .s2.basic800--text| Delete
              v-col.py-1.shrink()
                template(v-if="searchBarExpand")
                  v-btn.elevation-0.pa-0(color="transparent" small icon @click="filterSheet = true")
                    eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="23" style="margin-top: 2px")
                template(v-else)
                  v-btn.elevation-0.pa-0(text color="transparent" :ripple="false" x-small light @click="filterSheet = true")
                    eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="15" style="margin-top: 2px")
                    .label.primary400--text| Filter
            v-row(style="margin:0 -16px" v-if="Object.keys(filteredData).length > 0" )
              div.py-2.px-1(:style="`background-color: ${$vuetify.theme.themes[$theme].primary500} !important; width:100%`")
                div.d-flex
                  v-chip.ml-1.py-3(v-if="selectedOverdueFilter" color="basic100" close outlined close-icon="mdi-close" small @click:close="selectedOverdueFilter = null; searchItem()") {{ selectedOverdueFilter.name }}
                  v-chip.ml-1.py-3(v-if="selectedReminderFilter" color="basic100" close outlined close-icon="mdi-close" small @click:close="selectedReminderFilter = null; searchItem()") {{ selectedReminderFilter.name }}
                  //- v-chip.py-3.ml-1(v-if="selectedCategoryFilter" color="basic100" close outlined close-icon="mdi-close" small @click:close="selectedCategoryFilter = null; searchItem()") {{ selectedCategoryFilter.name }}
                  v-chip.py-3.ml-1(v-if="selectedStatusFilter" color="basic100" close outlined close-icon="mdi-close" small @click:close="selectedStatusFilter = null; searchItem()") {{ selectedStatusFilter.name }}
                  v-chip.py-3.ml-1(v-if="selectedDateRangeFilter" color="basic100" close outlined close-icon="mdi-close" small @click:close="selectedDateRangeFilter = null; selectedDateRange = null; searchItem()")
                    template(v-if="selectedDateRangeFilter.id === 'custom' && selectedDateRange.length > 0")
                      template(v-if="selectedDateRange.length > 1") {{ selectedDateRange[0] | humanizeDate }} ~ {{ selectedDateRange[1] | humanizeDate }}
                      template(v-else) {{ selectedDateRange[0] | humanizeDate }}
                    template(v-else) {{ selectedDateRangeFilter.name }}
    v-container.white.py-0.px-0(style="max-width:600px")
      v-layout.my-12(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .contain-layout(v-else)
        v-layout.my-12(v-if="incomes.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption Income not found or empty
        .items-layout(v-else)
          v-card( flat v-for="(income,index) in incomes" :key="index")
            IncomeItem(:parentIncome='income' :isFirstDate='isFirstDate(index)'
              @deleted="handleDeleteItem" @edited="handleEditItem" @selectInvoice="handleSelectItem"
              :checkboxActive="checkboxActive" :clickedItem="checkClick(income.rid)"
              :bulkActionType="bulkActionType")
      y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")
    v-footer.white.pa-0(v-if="checkboxActive" app inset fixed light)
      v-container.pa-0.px-4(style="max-width:600px")
        v-row(no-gutters align="center")
          v-col.py-2
            .s2.primary500--text You’ve selected {{selectedInvoice.length}} invoice(s)
          v-col.py-2.shrink
            v-btn.px-1.elevation-0(color="transparent" text height="40" @click="clearSelect")
              .button-Aa-medium.primary400--text| Cancel
          v-col.py-2.shrink
            v-btn.elevation-0(v-if="sendReminder"  color="info500" @click="showSendReminderDialog = true" height="40")
              .button-AA-medium.basic100--text Next
            v-btn.elevation-0(v-if="sendScheduleReminder"  color="info500" @click="showScheduleReminderDialog = true" height="40")
              .button-AA-medium.basic100--text Next
            v-btn.elevation-0(v-if="deleteInvoice"  color="danger500" @click="openDeleteDialog = true" height="40")
              .button-AA-medium.basic100--text Delete
    v-btn.mr-3.mb-6(v-if="!checkboxActive"  color='textColorAccent' dark fixed bottom right fab height="60" width="60" @click="showAddIncomeDialog = true")
      eva-icon(name="plus-outline" :fill="$vuetify.theme.themes[$theme].basic100" height="24" width="24" style="margin-left: -2px; margin-top: 2px;")

    .modals
      add-income(v-if="showAddIncomeDialog" :open.sync="showAddIncomeDialog" @added="handleAddItem")
      income-filter(v-if="filterSheet" :company="company" :filtered="filteredData" :open.sync="filterSheet" @filtered="handleFiltered")
      send-reminder(v-if="showSendReminderDialog" :open.sync="showSendReminderDialog" :selectedInvoices="selectedInvoice" @updateSelected="handleUpdateSelected")
      schedule-reminder(v-if="showScheduleReminderDialog" :open.sync="showScheduleReminderDialog" :selectedInvoices="selectedInvoice" )
      income-invoice(v-if="openInvoiceDialog" :open.sync="openInvoiceDialog" :parentIncome.sync="openingIncome")
      y-dialog(v-model="openDeleteDialog", max-width="290", persistent)
        v-card
          v-card-title.h6.basic800--text.px-4 Delete income
          v-card-text.p2.primary500--text.px-4
            | Are you sure you want to delete all {{selectedInvoice.length}} item(s)? All item(s) will be deleted permanently.
          v-card-actions
            v-spacer
            v-btn(color="white", text, @click="openDeleteDialog = false")
              .button-Aa-small.primary400--text Cancel
            v-btn(
              color="danger500",
              depressed,
              dark,
              @click="startDelete",
              :loading="isLoading"
            )
              .button-AA-small.basic100--text Delete

</template>

<script>
import { mapState } from 'vuex'
import queryString from 'query-string'
import AddIncome from '@/components/yezzabook/dialogs/income/addincome/AddIncome.vue'
import IncomeItem from '@/components/yezzabook/IncomeItem.vue'
import IncomeFilter from '@/components/yezzabook/IncomeFilter.vue'
import IncomeInvoice from '@/components/yezzabook/dialogs/income/IncomeInvoice.vue'
import SendReminder from '@/components/yezzabook/dialogs/SendReminder.vue'
import ScheduleReminder from '@/components/yezzabook/dialogs/ScheduleReminder.vue'

export default {
  name: 'YezzaBookIncome',
  components: { AddIncome, IncomeItem, IncomeFilter, IncomeInvoice, SendReminder, ScheduleReminder },
  props: ['company'],
  data: () => ({
    checkboxActive: false,
    count: 0,
    customDateRangePickerDialog: false,
    deleteInvoice: false,
    filterSheet: false,
    incomesSummaryMonth: null,
    incomesSummaryYear: null,
    incomes: [],
    isFetching: false,
    isFiltered: false,
    isLoading: false,
    lastScrollPosition: 0,
    loadingCount: 0,
    openDeleteDialog: false,
    openInvoiceDialog: false,
    openingIncome: null,
    page: 1,
    pageSize: 20,
    searchBarExpand: false,
    searchCountDown: null,
    searchText: '',
    searchfilter: '',
    selectedCategoryFilter: null,
    selectedDateRange: [],
    selectedDateRangeFilter: null,
    selectedFilter: 0,
    selectedInvoice: [],
    selectedOverdueFilter: null,
    selectedReminderFilter: null,
    selectedStatusFilter: null,
    sendReminder: false,
    sendScheduleReminder: false,
    showAddIncomeDialog: false,
    showHeader: true,
    showScheduleReminderDialog: false,
    showSendReminderDialog: false,
    totalLoadingCount: 0,
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapState('subscriptions', ['yBooksSubscription']),
    headerClass() {
      if((!this.showHeader || this.searchText.length > 0) && Object.keys(this.filteredData).length == 0){
        return 'hidden-header'
      }else if((!this.showHeader || this.searchText.length > 0) && Object.keys(this.filteredData).length > 0){
        return 'hidden-header-filtered'
      }else{
        return ''
      }
    },
    headerHeight() {
      if (this.searchText.length > 0 && Object.keys(this.filteredData).length == 0) {
        return 'height:45px'
      }else if(this.searchText.length > 0 && Object.keys(this.filteredData).length > 0) {
         return 'height:76px'
      }else if(this.searchText.length < 1 && Object.keys(this.filteredData).length > 0) {
         return 'height:225px'
      }else{
        return 'height:183px'
      }
    },
    filterParams () {
      let params = {
        page: 1,
        ordering: '-record_date,-rid',
        page_size: this.pageSize,
        expand: 'category,products'
      }
      if (this.searchText && this.searchText.length >= 2 && this.searchText.includes('#')) {
        params.rid = this.searchText.replace('#', '')
      } else if (this.searchText) {
        params.search = this.searchText
      }
      // if (this.member.role !== 'Admin') {
      //   params.member = this.member.id
      // }
      if (this.selectedStatusFilter) {
        if(this.selectedStatusFilter.id == 'paid'){
          params.paid = true
        }else{
          params.paid = false
        }
      }
      if (this.selectedOverdueFilter) {
        if(this.selectedOverdueFilter.id == 'yes'){
          params.overdue = true
        }else{
          params.overdue = false
        }
      }
      if (this.selectedReminderFilter) {
        if(this.selectedReminderFilter.id == 'sent'){
          params.reminder_sent = true
        }else{
          params.reminder_sent = false
        }
      }
      // if (this.selectedCategoryFilter) {
      //   params.category = this.selectedCategoryFilter.id
      // }
      if (this.selectedDateRangeFilter) {
        if (this.selectedDateRangeFilter.id === 'custom') {
          if (this.selectedDateRange.length === 1) {
            params.created_after = this.selectedDateRange[0]
            params.created_before = this.selectedDateRange[0]
          } else {
            if (this.selectedDateRange[0] < this.selectedDateRange[1]) {
              params.created_after = this.selectedDateRange[0]
              params.created_before = this.selectedDateRange[1]
            } else {
              params.created_after = this.selectedDateRange[1]
              params.created_before = this.selectedDateRange[0]
            }
          }
        } else {
          params.range = this.selectedDateRangeFilter.id
        }
      }
      params.ids = this.incomes.reduce((result, income)=> {return income.selected ? result+income.id + ',' : result}, '')
      return params
    },
    filteredData () {
      let data = {}
      // this.selectedCategoryFilter ? data.category = this.selectedCategoryFilter : null
      this.selectedOverdueFilter ? data.overdue = this.selectedOverdueFilter : null
      this.selectedReminderFilter ? data.reminder = this.selectedReminderFilter : null
      this.selectedStatusFilter ? data.status = this.selectedStatusFilter : null
      this.selectedDateRangeFilter ? data.range = this.selectedDateRangeFilter : null
      this.selectedDateRangeFilter ? data.selectedDateRange = this.selectedDateRange : null
      return data
    },
    bulkActionType () {
      if (this.sendReminder) {
        return 'send_reminder'
      } else if (this.sendScheduleReminder) {
        return 'scheduled_reminder'
      } else if (this.deleteInvoice) {
        return 'delete_invoice'
      } else {
        return null
      }
    }
  },
  mounted (){
    if (!this.$route.query.page) {
      this.fetchIncomes(1)
    } else {
      this.fetchIncomes(this.$route.query.page)
    }
    window.addEventListener('scroll', this.onScroll)
    this.fetchIncomesSummary()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.showHeader = true
        this.fetchIncomes(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    },
    selectedFilter(val) {
      const filter = this.filters[val]
      this.searchfilter = filter.value
      this.searchItem()
    },
    loadingCount (val) {
      if (val) {
        if (val === this.totalLoadingCount) {
          this.isLoading = false
          this.openUpdateStatusDialog = false
          this.openDeleteDialog = false
          this.newStatus = {}
          this.totalLoadingCount = 0
        }
      }
    },
    totalLoadingCount (val) {
      if (!val) {
        this.loadingCount = 0
      }
    },
    isFetching (val) {
      if (val) {
        this.showHeader = true
      }
    }
  },
  methods: {
    fetchIncomesSummary () {
      this.$axios.get(`/books/${this.company.slug}/incomes/summary?span=month`)
        .then((response) => {
          this.incomesSummaryMonth = response.data
        })
        .catch(() => {})
      this.$axios.get(`/books/${this.company.slug}/incomes/summary?span=year`)
        .then((response) => {
          this.incomesSummaryYear = response.data
        })
        .catch(() => {})
    },
    fetchIncomes(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let queryString = Object.keys(this.filterParams).filter((key) => key !== 'page').map(key => key + '=' + this.filterParams[key]).join('&')
      let url = `/books/${this.company.slug}/incomes/?page=${page}&${queryString}`
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.incomes = response.data.results
        this.count = response.data.count
      })
      .catch(() => {})
    },
    searchItem () {
      this.isFetching = true
      this.page = 1
      this.$axios.get(`/books/${this.company.slug}/incomes/`, { params: this.filterParams })
        .then((response) => {
          this.isFetching = false
          this.incomes = response.data.results
          this.count = response.data.count
        })
        .catch(() => {})
    },
    handleFiltered (data) {
      // this.selectedCategoryFilter = data.category || null
      this.selectedOverdueFilter = data.overdue || null
      this.selectedReminderFilter = data.reminder || null
      this.selectedStatusFilter = data.status || null
      this.selectedDateRangeFilter = data.range || null
      if (data.range) {
        this.selectedDateRange = data.selectedDateRange
      }
      this.searchItem()
      // this.filteredData = data
    },
    handleSelectItem(data){
      if (this.selectedInvoice.filter(f => f.id === data.id).length == 0) {
        this.selectedInvoice.push(data)
      }else{
        this.selectedInvoice = this.selectedInvoice.filter((x) => x.id !== data.id)
      }
    },
    handleUpdateSelected(data){
      this.selectedInvoice =  data
      this.fetchIncomes(1)
    },
    checkClick(id){
      if (this.selectedInvoice.filter(f => f.rid === id).length === 0) {
        return false
      }else{
        return true
      }
    },
    isFirstDate(index){
      var indexBefore = index - 1
      if (indexBefore < 0) {
        return true
      }else{
        var month = this.incomes[index].record_date.toString().split('-')[1]
        var monthBefore = this.incomes[indexBefore].record_date.toString().split('-')[1]
        if (month == monthBefore) {
          return false
        }else{
          return true
        }
      }
    },
    clearSelect () {
      this.checkboxActive = false
      this.deleteInvoice = false
      this.sendReminder = false
      this.sendScheduleReminder = false
      this.selectedInvoice = []
      this.fetchIncomes(1)
    },
    bulkReminder () {
      this.sendScheduleReminder = false
      this.deleteInvoice = false
      this.checkboxActive = true
      this.sendReminder = true
    },
    bulkScheduleReminder () {
      this.deleteInvoice = false
      this.checkboxActive = true
      this.sendReminder = false
      this.sendScheduleReminder = true
    },
    bulkDelete () {
      this.sendScheduleReminder = false
      this.sendReminder = false
      this.checkboxActive = true
      this.deleteInvoice = true
    },
    startDelete () {
      this.isLoading = true
      this.selectedInvoice.forEach(income => {

        this.axios.patch(`/leads/${income.pid}/`, { status: 'deleted' })
        .then(() => {
          this.incomes = this.incomes.filter((x) => x.id !== income.id)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })

      });
      var page = 1
      if (this.$route.query.page) {
        page = this.$route.query.page
      }
      setTimeout(() => this.fetchIncomes(page), 2000);
      this.isLoading = false
      this.selectedInvoice = []
      this.openDeleteDialog = false
    },
    onScroll () {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 85) {
        return
      }
      // Here we determine whether we need to show or hide the navbar
      this.showHeader = currentScrollPosition <= this.lastScrollPosition
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition
    },
    handleAddItem (item) {
      this.incomes.splice(0, 0, item)
      this.openingIncome = item
      if (item.payment_status !== 'paid') {
        this.openInvoiceDialog = true
      }
      this.fetchIncomesSummary()
    },
    handleEditItem (item) {
      let editIndex = 0
      this.incomes.forEach((income, index) => {
        if (income.id === item.id) {
          editIndex = index
        }
      })
      this.incomes = this.incomes.filter((x) => x.id !== item.id)
      this.incomes.splice(editIndex, 0, item)
    },
    handleDeleteItem (item) {
      this.incomes = this.incomes.filter((x) => x !== item)
      this.fetchIncomesSummary()
    },
    checkSearch () {
      if (!this.searchText) {
        this.searchBarExpand = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


<style scoped>
.border-bottom{
    border-bottom: 1px solid var(--v-basic300);
    border-radius: 0 !important;
}
.sticky-header-container {
  position: relative;
  background-color: var(--v-basic100);
  /* height: 183px; */
}
.sticky-header{
  position: fixed;
  transition: 0.3s all ease-out;
  transform: translate3d(0, 0, 0) !important;
  z-index: 3;
  width: 100%;
  max-width: 600px;
  background-color: var(--v-basic100);
  margin-top: -13px;
  padding-top: 10px;
}
.sticky-header.hidden-header{
    transform: translate3d(0, -70%, 0) !important;
}
.sticky-header.hidden-header-filtered{
    transform: translate3d(0, -60%, 0) !important;
}
@media(min-width: 980px){
  .sticky-header.hidden-header{
    transform: translate3d(0, -70%, 0) !important;
  }
  .sticky-header.hidden-header-filtered{
    transform: translate3d(0, -60%, 0) !important;
}
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

/* custom v-select CSS */

div >>> .v-list-item__title{
  font-size: 15px !important;
  font-weight: 600 !important;
  line-height: 24px !important;
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white;
}
div >>> .menuable__content__active{
  box-shadow: none !important;
}
div >>> .v-select.v-input--dense .v-select__selection--comma{
  font-size: 15px !important;
  font-weight: 600 !important;
  line-height: 24px !important;
}
</style>

<i18n>
{
  "en": {
    "tooltip": {
      "income": "Amount of settled and unpaid income for this month.",
      "settled": "Amount of payments you have received, including partial payments.",
      "unpaid": "Amount of unpaid income, including those overdue and not yet due, for this acccounting year.",
      "overdue": "Amount of unpaid income that are past their due date. Make sure to collect your debts."
    }
  }
}
</i18n>